import { Space } from 'antd';
export default Space;
